(function () {
'use strict';

function queryString(search = location.search) {
  const query = {};
  if (search) {
    const params = search.substring(1).split('&');
    params.forEach(item => {
      const kv = item.split('=');
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1]);
      }
    });
  }
  return query;
}

const params = queryString();

let _index = 1000;

let _fakeInvoke = (eventName, cb_1, cb_2) => {
  //ignore the second callback for now, hasn't decided how to commonlize this process
  console.log(eventName);

  if (cb_2) {
    console.log(cb_2);
  }

  if (eventName == "stopRecord") {
    setTimeout(function(){
      cb_1("uploadFile");
    }, 100);
    setTimeout(function(){
      cb_2("{ \"status\": \"-11\" }");
    }, 500);
  } else {
    if ("function" === typeof cb1) {
      setTimeout(function(){cb_1(null);}, 100);
    } else {
      console.log(cb_1);
    }
  }
};

const CALLBACK_FUNCS = [
  'nativeMinimize', 
  'onActive',
  'onSuspend'
];

let isCallbackFunction = (eventName) => {
  return CALLBACK_FUNCS.indexOf(eventName) !== -1;
};

let _key = (fn, event) => {
  let key = '_cb' + _index;
  _index = _index + 1;

  window[key] = function () {
    try {
      fn.apply(window, arguments);
      if (!isCallbackFunction(event)) {
        delete window[key];
      }
    } catch(e) {
      //should exception to track server
      console.log(e);
    }

    return 'success';
  };

  return key;
};

let NativeInterface = {
  invoke: function(event, cb_1, cb_2) {
    let args = [].slice.call(arguments, 1), _len = args.length;
    for (var i = 0; i < _len; i++) {
      if (typeof args[i] === 'function') { args[i] = _key(args[i], event); }
    }

    try {
      if (params.debug === 'true') {
        _fakeInvoke(event, cb_1, cb_2);
      } else if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
        if (params.appVersion >= '3.1' || params.appId === 'lingocc') {
          window.webkit.messageHandlers.LLSiOS.postMessage({
            eventName: event,
            args: args
          });
        } else {
          // old ios invoking logic
          var urlScheme = "lls://" + event + "/" + args.join('/');
          window.location = urlScheme;
        }
      } else {
        if (_len === 3) {
          window.LLSAndroid.invoke(event, args[0], args[1], args[2]);
        } else if (_len === 2) {
          window.LLSAndroid.invoke(event, args[0], args[1]);
        } else {
          window.LLSAndroid.invoke(event, args[0]);
        }
      }
    } catch(e) {
      console.log('invoke error : ', e);
    }
  }
};

const DEFAULT_CATEGORY = 'all';
const DEFAULT_APP_NAME = 'lls';
const APP_MARKETING_VERSION = '1.0';
const TRACK_URL = 'https://flm3.llsapp.com/data_collect';

function Track(config = {}) {
  this.query = this.queryString(location.search);
  this.category = config.category || DEFAULT_CATEGORY;
  this.app_name = config.app_name || DEFAULT_APP_NAME;
  this.app_version = config.app_version || APP_MARKETING_VERSION;
}

Track.prototype = {
  makeRandomIdStr(strLen) {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let text = '';
    for(let i = 0; i < strLen; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  },
  getSessionId() {
    let sessionId = window.sessionStorage.getItem('sessionId');
    if(!sessionId) {
      sessionId = Math.floor(Date.now() / 1000) + '.' + this.makeRandomIdStr(6);
      window.sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  },
  getTempUserId() {
    return 'tmp' + this.getSessionId();
  },
  buildTrackPackage(trackData) {
    const commonData = {
      platform: this.category,
      session_id: this.getSessionId(),
      app_marketing_version: this.app_version
    };
    trackData.time = this._formatedTimeNow();
    return {
      user_id: this.getTempUserId(),
      app_name: this.app_name,
      common_data: commonData,
      batch_data: [{
        event_type: 22,
        payload: trackData
      }]
    };
  },
  _zeroFill(num, targetLength) {
    const absNum = Math.abs(num).toString();
    const zerosToFill = targetLength - absNum.length;
    return Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNum;
  },
  _formatedTimeNow() {
    const t = new Date();
    const year = t.getFullYear();
    const month = this._zeroFill(t.getMonth() + 1, 2);
    const day = this._zeroFill(t.getDate(), 2);
    const hour = this._zeroFill(t.getHours(), 2);
    const minutes = this._zeroFill(t.getMinutes(), 2);
    const seconds = this._zeroFill(t.getSeconds(), 2);
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
  },
  normalizeTrackpayload(params) {
    const normalizedPayload = {};
    for (let key in params) {
      normalizedPayload[this._dasherize(key)] = params[key];
    }
    return normalizedPayload;
  },
  _dasherize(str) {
    return /[A-Z]/g.test(str) ? str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase() : str;
  },
  queryString(text) {
    const query = {};
    if (text) {
      const params = text.substring(1).split('&');
      params.forEach(item => {
        const kv = item.split('=');
        query[kv[0]] = decodeURIComponent(kv[1]);
      });
    }
    return query;
  },
  xhr(options) {
    const request = new XMLHttpRequest();
    request.open(options.type, options.url, true);
    request.setRequestHeader('Content-Type', options.contentType);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (typeof options.success === 'function') {
          options.success();
        }
      } else {
        if (typeof options.error === 'function') {
          options.error();
        }
      }
    };
    request.send(options.data);
  },
  send(params, success) {
    const trackData = this.normalizeTrackpayload(params);
    if(!trackData.channel && this.query.channel) {
      trackData.channel = this.query.channel;
    }
    const trackPackage = this.buildTrackPackage(trackData);
    this.xhr({
      url: TRACK_URL,
      data: JSON.stringify(trackPackage),
      type: 'POST',
      contentType: 'application/json',
      success : success || function () {}
    });
  },
  sendPageTrackEx(params = {}, success) {
    params.action = 'page_view';
    this.send(params, success);
  },
  sendActionTrackEx(params, success) {
    this.send(params, success);
  },
  sendPageTrack(pageName, category, params, afterTrack) {
    params = params || {};
    params.pageName = pageName;
    params.category = category || this.category;
    this.extendSourceTypeParams(params);
    NativeInterface.invoke('doPage', () => {
      if (typeof afterTrack === 'function') {
        afterTrack();
      }
    }, JSON.stringify(params));
  },
  sendActionTrack(actionName, params, afterTrack) {
    params = params || {};
    params.action = actionName;
    params.channel = this.query.channel || '';
    this.extendSourceTypeParams(params);
    NativeInterface.invoke('doAction', () => {
      if (typeof afterTrack === 'function') {
        afterTrack();
      }
    }, JSON.stringify(params));
  },
  sendTrack(type = 'page', actionOrPageName, success) {
    if (type === 'page') {
      this.sendPageTrack({
        pageName: actionOrPageName
      }, success);
    } else {
      this.sendActionTrack({
        action: actionOrPageName
      }, success);
    }
  },
  extendSourceTypeParams(params) {
    const orderSourceType = this.query.orderSourceType;
    if (orderSourceType) {
      params.source_type = orderSourceType;
    }
  }
};

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    window.FastClick.attach(document.body);
  }, false);
}

const BASE_API_URL = /staging/.test(location.href) ? 'https://staging-neo.llsapp.com' : 'https://apineo.llsapp.com';
const channel_name = queryString().channel || '';

if (queryString().ad === '20170720') {
  const $ad = document.querySelector('.ad');
  $ad.style.height = window.innerHeight + 'px';
  $ad.style.backgroundImage = 'url("https://cdn.llscdn.com/fe-static/lingome/tmp/banner-qLmK8sbf.jpg")';
}

if (channel_name === '2fb014948eaa266bf9a305d77379b7b5') {
  const $logo = document.querySelector('.tmp-logo');
  $logo.innerHTML = '<img src="https://cdn.llscdn.com/fe-static/tmp/weibo-vip-logo2-HSfDDVIl.png" alt="logo">';
}

const track = new Track({
  platform: 'all'
});

function App(config) {
  this.$form = document.getElementById('register');
  this.$mobile = this.$form.querySelector('input.mobile');
  this.$code = this.$form.querySelector('input.code');
  this.$getCodeBtn = this.$form.querySelector('.getcode');
  this.$submit = this.$form.querySelector('.submit');
  this.$toast = document.querySelector('.toast');
  this.timeout = config.timeout;
  this.timer = null;
}

App.prototype = {
  init() {
    this.listen();
    track.sendPageTrackEx({
      pageName: 'external_activity_register_give_course',
      category: 'web',
      channel_id: channel_name
    });
  },
  listen() {
    let buttonLock = false;
    const iosDownload = document.querySelector('a.ios');
    const androidDownload = document.querySelector('a.android');
    if (/iPhone|iPad|iPod|iOS/ig.test(window.navigator.userAgent)) {
      androidDownload.style.display = 'none';
    } else {
      iosDownload.style.display = 'none';
    }
    this.$getCodeBtn.addEventListener('click', () => {
      if (buttonLock) {
        return false;
      }
      buttonLock = true;
      track.sendActionTrackEx({
        pageName: 'external_activity_register_give_course',
        category: 'web',
        action: 'click_authcode',
        channel_id: channel_name
      });
      if (this.timer) {
        return false;
      }
      const mobile = this.$mobile.value;
      if (mobile.length === 0) {
        this.errorMsg('请先输入您的手机号！');
      } else if (mobile.length !== 11) {
        this.errorMsg('您的手机号格式不正确！');
      } else {
        this.$getCodeBtn.disabled = true;
        this.getCode({
          mobile: mobile,
          success: () => {
            buttonLock = false;
            this.$getCodeBtn.disabled = true;
            this.$getCodeBtn.textContent = this.timeout + 's';
          },
          error: () => {
            buttonLock = false;
            this.$getCodeBtn.disabled = false;
          },
          tick: (time) => {
            this.$getCodeBtn.textContent = time + 's';
          },
          finish: () => {
            buttonLock = false;
            this.$getCodeBtn.disabled = false;
            this.$getCodeBtn.textContent = '获取验证码';
          },
        });
      }
    }, false);
    this.$submit.addEventListener('click', ev => {
      ev.preventDefault();
      ev.stopPropagation();
      if (buttonLock) {
        return false;
      }
      buttonLock = true;
      this.$submit.disabled = true;
      track.sendActionTrackEx({
        pageName: 'external_activity_register_give_course',
        category: 'web',
        action: 'click_submit',
        channel_id: channel_name
      });
      const mobile = this.$mobile.value;
      const code = this.$code.value;
      if (mobile.length > 0 && code.length > 0) {
        this.$submit.textContent = '注册中...';
        this.$submit.disabled = true;
        this.register({
          mobile: mobile,
          code: code,
          success: (data) => {
            buttonLock = false;
            this.$submit.textContent = '领取免费课程';
            this.$submit.disabled = false;
            iosDownload.href = data.iosDownloadUrl;
            androidDownload.href = data.androidDownloadUrl;
            document.getElementById('landing').style.display = 'none';
            document.getElementById('result').style.display = 'block';
            window.ga('send', {
              hitType: 'event',
              eventCategory: 'campaign',
              eventAction: 'register_success',
              eventLabel: channel_name
            });
            track.sendPageTrackEx({
              pageName: 'external_activity_register_give_course_download',
              category: 'web',
              channel_id: channel_name
            });
          },
          error: () => {
            buttonLock = false;
            this.$submit.textContent = '领取免费课程';
            this.$submit.disabled = false;
          },
        });
      } else {
        this.errorMsg('短信验证码不正确！');
      }
    }, false);
    iosDownload.addEventListener('click', () => {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'campaign',
        eventAction: 'download_ios',
        eventLabel: channel_name
      });
      track.sendActionTrackEx({
        pageName: 'external_activity_register_give_course_download',
        category: 'web',
        action: 'download_ios',
        channel_id: channel_name
      });
    }, false);
    androidDownload.addEventListener('click', () => {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'campaign',
        eventAction: 'download_android',
        eventLabel: channel_name
      });
      track.sendActionTrackEx({
        pageName: 'external_activity_register_give_course_download',
        category: 'web',
        action: 'download_android',
        channel_id: channel_name
      });
    }, false);
    document.querySelector('.show-detail').addEventListener('click', () => {
      const $rule = document.querySelector('.rule');
      if ($rule.style.display === 'block') {
        $rule.style.display = 'none';
      } else {
        $rule.style.display = 'block';
      }
    });
  },
  getCode(options) {
    this.xhr({
      url: BASE_API_URL + '/api/v1/external_registrations/code',
      data: JSON.stringify({
        appId: 'lls',
        mobile: options.mobile,
      }),
      type: 'POST',
      contentType: 'application/json',
      success: (resp) => {
        const data = JSON.parse(resp);
        if (data.success) {
          options.success();
          this.countdown(options.tick, options.finish);
        }
      },
      error: (resp) => {
        this.$getCodeBtn.textContent = '获取验证码';
        this.$getCodeBtn.disabled = false;
        const data = JSON.parse(resp);
        options.error();
        this.errorMsg(data.error);
      },
    });
  },
  register(options) {
    this.xhr({
      url: BASE_API_URL + '/api/v1/external_registrations',
      data: JSON.stringify({
        appId: 'lls',
        mobile: options.mobile,
        code: options.code,
        channelId: channel_name,
      }),
      type: 'POST',
      contentType: 'application/json',
      success: (resp) => {
        const data = JSON.parse(resp);
        if (data.success) {
          options.success(data);
        } else {
          this.errorMsg(data.error);
        }
      },
      error: (resp) => {
        const data = JSON.parse(resp);
        options.error();
        this.errorMsg(data.error);
      },
    });
  },
  countdown(tick, finish) {
    let current = this.timeout;
    this.timer = window.setInterval(() => {
      current--;
      if (current > 0) {
        tick(current);
      } else {
        finish();
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }, 1000);
  },
  xhr(options) {
    const request = new XMLHttpRequest();
    request.open(options.type, options.url, true);
    request.setRequestHeader('Content-Type', options.contentType);
    request.onload = () => {
      const resp = request.responseText;
      if (request.status >= 200 && request.status < 400) {
        if (typeof options.success === 'function') {
          options.success(resp);
        }
      } else {
        if (typeof options.error === 'function') {
          options.error(resp);
        }
      }
    };
    request.onerror = () => {
      options.error(JSON.stringify({error: '网络异常，请稍后再试'}));
    };
    request.send(options.data);
  },
  errorMsg(msg) {
    this.$toast.querySelector('.content').textContent = msg;
    this.$toast.style.display = 'table';
    window.setTimeout(() => {
      this.$toast.style.display = 'none';
    }, 3000);
  },
};

const app = new App({
  timeout: 60,
});
app.init();

}());
